import React from "react";

const ExploratoryAnalysis = ({backendApiPrefix}) => {
    return (
        <div className="home">
            <h1>ExploratoryAnalysis</h1>
        </div>
    );
};

export default ExploratoryAnalysis